export default __webpack_public_path__ + "static/media/information-icon.2943331d.svg";